module.exports = __webpack_public_path__ + "img/book.acacc9e6.png";